<template>
  <div class="pageDiv">
    <v-card class="main-card">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Players ({{displayPlayers.length}} found)</span>
      </v-card-title>
      <v-card class="letter-div">
        Select first letter of first name:
        <div class="letterContainer">
          <a class="letter-btn"
             v-for="letter in lettersMap" :key="letter"
             :class="{letterSelected: selectedLetter === letter.value}"
             @click="updateList(letter.value)">{{letter.key}}</a>
        </div>
      </v-card>

      <v-card class="player-card" v-if="displayPlayers.length === 0">
        No Players found {{displayPlayers.length}}
      </v-card>

      <v-card class="player-card"
              v-for="memberPlayer in displayPlayers" :key="memberPlayer.playerId">
        <div class="p-card">
          <div class="player-img-div">
            <v-img class="player-img" :src="'/images/players/' + memberPlayer.player.photoName">
            </v-img>
          </div>

          <v-card-text class="">
            <span class="label14">Name: </span>
            {{memberPlayer.player.firstName}} {{memberPlayer.player.middleName}} {{memberPlayer.player.lastName}}
            <v-img class="member-logo" v-if="memberPlayer.membership" src="../../assets/img/okaga-logo-mini.png">
            </v-img>
            <br>
            <span class="label14">Flight: </span> {{memberPlayer.player.defaultFlight}}<br>
            <span class="label14">HCP: </span> {{getScoreHcp(memberPlayer.player.dfwvgaHandicap, memberPlayer.player.handicap, 1)}}<br>
            <span class="label14">Shirt Size: </span> {{memberPlayer.player.shirtSize}}<br>

            <a class="label14 link" @click="getPlayerScore(memberPlayer);memberPlayer.player.seeScores=true;">See tournament scores & HCP</a>
          </v-card-text>
        </div>

        <div class="p-card" v-if="selectedPlayer !== null && memberPlayer.player.seeScores">
          <v-card-text v-if="playerScores.length > 0">
            <v-simple-table class="simple-table">
              <tr>
                <th width="10px">#</th>
                <th width="100px">Date</th>
                <th v-if="!$AuthSvc.isMobile()">Flight</th>
                <th v-if="!$AuthSvc.isMobile()">HCP</th>
                <th>Course</th>
                <th>Score</th>
                <th>Diff</th>
              </tr>
              <tr v-for="(player, index) in playerScores" :key="player.playerId">
                <td>{{index+1}}</td>
                <td>{{player.scoreDate}}</td>
                <td v-if="!$AuthSvc.isMobile()">{{player.flight}}</td>
                <td v-if="!$AuthSvc.isMobile()">{{Number(player.handicap).toFixed(2)}}</td>
                <td>{{player.courseName}}</td>
                <td>{{player.thruHoles===18?player.score:"DNF"}}</td>
                <td :class="{hcpSelected: player.hcpSelected==='Y'}">{{getScoreHcp(player.scoreHandicap, "",2)}}</td>
              </tr>
              <tr>
                <td class="hcpLine"></td>
                <td class="hcpLine"></td>
                <td class="hcpLine" v-if="!$AuthSvc.isMobile()"></td>
                <td class="hcpLine" v-if="!$AuthSvc.isMobile()"></td>
                <td class="hcpLine"></td>
                <td class="hcpLine label16">HCP</td>
                <td class="hcpLine label16">{{toScoreStr(memberPlayer.player.dfwvgaHandicap)}}</td>
              </tr>
            </v-simple-table>
          </v-card-text>

          <div v-if="playerScores.length === 0">
            <span class="noScores">No scores recorded.</span>
          </div>
        </div>
      </v-card>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: "login",
    data: () => ({
      count: 0,
      selectedPlayer: null,
      playerScores: [],
      memberPlayers: [],
      displayPlayers: [],
      selectedLetter: '',
      lettersMap: [
        {"key":"A-C", "value":"ABC"},
        {"key":"D-F", "value":"DEF"},
        {"key":"G-I", "value":"GHI"},
        {"key":"J-L", "value":"JKL"},
        {"key":"M-O", "value":"MNO"},
        {"key":"P-S", "value":"PQRS"},
        {"key":"T", "value":"T"},
        {"key":"U-Z", "value":"UVWXYZ"}
      ],
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I','J','K','L','M','N','O','P','Q','R','S',
                'T','U','V','W','X','Y','Z']
    }),
    mounted: function() {
      this.loadPlayers();
    },
    methods: {
      loadPlayers() {
        var _this = this;
        this.selectedLetter = this.lettersMap[0].value;
        this.axios.get('/public/players/letter/' + this.lettersMap[0].value)
        .then(function (response) {
            _this.memberPlayers = response.data;
            for(var i=0; i < _this.memberPlayers.length; i++) {
              _this.memberPlayers[i].player.match = true;
              _this.memberPlayers[i].player.seeScores = false;
            }
            _this.displayPlayers = _this.memberPlayers;
        })
        .catch(function (error) {
            console.log('ERROR 1: ' + error);
        });
      },
      toScoreStr(handicap) {
        if (handicap > 50) {
          return "N/A"
        } else {
          return Number(handicap).toFixed(2);
        }
      },
      getScoreHcp(scoreHcp, overrideHcp, precision) {
        var hcp = scoreHcp;
        if (overrideHcp != null && overrideHcp !== '') {
          hcp = overrideHcp;
        }

        if (hcp === '') {
          return "N/A";
        }

        if (hcp > 60.00) {
          return "N/A";
        }
        else {
          return Number(hcp).toFixed(precision);
        }
      },
      processKey(event) {
        if (event.keyCode === 13) {
          this.updateList();
        }
      },
      updateList(letter) {
        var _this = this;

        _this.selectedLetter = letter;
        this.axios.get('/public/players/letter/' + letter)
        .then(function (response) {
            _this.memberPlayers = response.data;
            for(var i=0; i < _this.memberPlayers.length; i++) {
              _this.memberPlayers[i].match = true;
            }
            _this.displayPlayers = _this.memberPlayers;
        })
        .catch(function (error) {
            console.log('ERROR 2: ' + error);
        });
      },
      membershipChange(memberPlayer) {
        if (memberPlayer.membership) {
          this.axios.post('/admin/member/' + this.$AuthSvc.getYear() + '/'+memberPlayer.playerId)
          .then(function (response) {
            console.log("SUCCESS: " + response.data);
          })
          .catch(function (error) {
            console.log('ERROR 3: ' + error);
          });
        } else {
          this.axios.delete('/admin/member/' + this.$AuthSvc.getYear() + '/'+memberPlayer.playerId)
          .then(function (response) {
            console.log("SUCCESS: " + response.data);
          })
          .catch(function (error) {
            console.log('ERROR 4: ' + error);
          });
        }
      },
      excludeTcChange(memberPlayer) {
        if (memberPlayer.player.excludeTc==='Y') {
          this.axios.post('/admin/exclude-tc/'+memberPlayer.playerId)
          .then(function (response) {
            console.log("SUCCESS: " + response.data);
          })
          .catch(function (error) {
            console.log('ERROR 5: ' + error);
          });
        } else {
          this.axios.delete('/admin/exclude-tc/'+memberPlayer.playerId)
          .then(function (response) {
            console.log("SUCCESS: " + response.data);
          })
          .catch(function (error) {
            console.log('ERROR 6: ' + error);
          });
        }
      },
      getPlayerScore(memberPlayer) {
        var _this = this;

        _this.playerScores = [];

        this.axios.get('/public/scores-history/players/'+memberPlayer.playerId)
        .then(function (response) {
          console.log("SUCCESS: " + response.data);
          _this.playerScores = response.data;
          _this.selectedPlayer = memberPlayer;

          for(var i=0; i < _this.displayPlayers.length; i++) {
            if (_this.displayPlayers[i].player.playerId === _this.selectedPlayer.player.playerId) {
              _this.displayPlayers[i].player.seeScores = true;
              console.log('BINH: ' + _this.displayPlayers[i].player.playerId + ' see scores');
            } else {
              _this.displayPlayers[i].player.seeScores = false;
            }
          }
        })
        .catch(function (error) {
          console.log('ERROR 1: ' + error);
        });
      }
    }
  }

</script>

<style scoped>

    .p-card {
      width: 100%;
    }

    select {
      margin-right: 10px;
    }

    .checkbox {
      height: 20px;
      width: 20px;
    }

    .input-text {
      width: 60px;
      border: 1px solid black;
      border-radius: 5px;
      padding: 3px 7px !important;
    }

    .btn-action {
      display: inline-block;
    }

    .label {
      font-size: 14px;
      font-weight: bold;
      display: inline-block;
      width: 100px;
    }

    .player-card {
      margin: 10px 0;
      padding: 10px;
      min-height: 200px !important;
    }

    .player-subcard span {
      display: inline-block;
      margin-right: 12px;
    }

    .player-content {
      margin: 7px 10px !important;
      height: 28px;
    }

    .actions-card {
      display: inline-block;
      float: right;
      width: 80px !important;
    }

    .noShow {
      display: none;
    }

    .hcpLine {
      border: 0px;
      background-color: lightgray;
    }

    .letterContainer {
      display: inline-block;
      width: 100%;
      padding: 7px;
    }

    .noScores {
      font-size: 18px;
      font-weight: bold;
      color: red;
    }

    @media (min-width: 768px) {
      .player-subcard {
        display: flex;
        padding: 5px;
        width: 300px !important;
      }

      .player-score-subcard {
        display: flex;
        padding: 5px;
        width: 100% !important;
      }

      .player-content {
        width: 240px;
        height: 28px;
      }

      .letter-div {
        display: inline-block;
        width: 100%;
      }

      td, th {
        font-size: 14px;
      }
    }

    .letter-btn {
      display: inline-block;
      font-size: 20px;
      font-weight: 900;
      margin: 5px;
      padding: 5px !important;
      background-color: #0f0e0f !important;
      color: white;
      border-radius: 5px;
    }

    .p-card {
      display: flex;
    }

    .player-img-div {
      position: relative;

      width: 140px;
      margin-right: 20px;
    }

    .player-img {
      border-radius: 7px;
      margin-bottom: 10px;
      max-height: 175px;
    }

    .letterSelected {
      color: #163b7a;
      background-color: #c3dbfa !important;
    }

    .membership {
      font-size: 14px;
      font-weight: bold;
      color: darkgreen;
    }

    .memberColor {
      background-color: antiquewhite;
    }

    .hcpSelected {
      background-color: lightgray;
    }

    .member-logo {
      display: inline-block;
      height: 40px;
      width: 40px;
      border-radius: 45px;
      margin-left: 10px;
    }

</style>